import { useCallback, useState } from "react";

import type { AudioPlayerSeekRequest } from "../../ui";

// The audio strip's transport state as the canvas sees it: the controlled
// seek (every request carries a fresh nonce so the same position can be
// requested twice) plus the playback position and play state the player
// reports back, so the conversation can follow the utterance being played.
export interface AudioTransport {
  currentMs: number | null;
  isPlaying: boolean;
  onPlayingChange: (playing: boolean) => void;
  onTimeUpdate: (ms: number) => void;
  requestSeek: (startMs: number) => void;
  seekRequest: AudioPlayerSeekRequest | null;
}

export function useAudioTransport(): AudioTransport {
  const [seekRequest, setSeekRequest] = useState<AudioPlayerSeekRequest | null>(
    null,
  );
  const [currentMs, setCurrentMs] = useState<number | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const requestSeek = useCallback((startMs: number) => {
    setSeekRequest((prev) => ({ ms: startMs, nonce: (prev?.nonce ?? 0) + 1 }));
  }, []);
  return {
    currentMs,
    isPlaying,
    onPlayingChange: setIsPlaying,
    onTimeUpdate: setCurrentMs,
    requestSeek,
    seekRequest,
  };
}
